import ModalPreviewDocument from './ModalPreviewDocument-redux';

export default ModalPreviewDocument;
